import { Row, Col } from 'react-bootstrap';
import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import './SelfRegisterFinish.css';

const SelfRegisterFinish = () => {
  return (
    <Row className='register-success-container'>
      <Col className='text-start'>
        <h2>¡Listo!, ya eres parte de happ. 👏 </h2>
        <h6>Has finalizado con éxito el proceso de registro.  </h6>
        <h6>Ya puedes realizar tu evaluación preventiva de salud. </h6>
        <h6><strong>Gracias por comenzar tu viaje de salud con happ, estamos aquí para cuidar de ti.</strong> 🤲</h6>
      </Col>
    </Row>
  );
}

export default SelfRegisterFinish;